const preTitle = {
    fontFamily: 'NotoSansKR, SackersGothicStd, sans-serif',
    fontSizeSmall: '14px',
    fontSizeMedium: '16px',
    lineHeightSmall: '22px',
    lineHeightMedium: '24px'
  }
  
  const title = {
    fontFamily: 'NotoSansKR, SackersGothicStd, sans-serif',
    fontSizeSmall: '24px',
    fontSizeMedium: '32px',
    lineHeightSmall: '32px',
    lineHeightMedium: '40px',
    widthSmall: '240px',
    widthMedium: '320px'
  }
  
  const textStyles = {
    name: '4',
    type: 'Paragraph'
  }
  
  export default {
    preTitle,
    title,
    textStyles
  }
  